export default {
    ByArtistMode: 0,
    ByHeadlinerMode: 1,
    ByDayMode: 2,
    FullMode: 3
}
